var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-4"},[_c('RouterLink',{staticClass:"navbar-item-title",class:{
      selected: _vm.item.isSelected
    },attrs:{"tag":"button","type":"button","to":_vm.item.to}},[_vm._v(" "+_vm._s(_vm.item.title)+" ")]),_c('div',{staticClass:"bottom-bar",class:{ selected: _vm.item.isSelected }})],1)}
var staticRenderFns = []

export { render, staticRenderFns }